import Swiper, { Navigation, Pagination } from 'swiper';
import lazyLoad from './../utils/lazy'

Swiper.use([Navigation, Pagination]);

const cImageSliderInit = () => {

    var imageSlider = new Swiper(".js-image-slider", {
        slidesPerView: 'auto',
        spaceBetween: 10,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        navigation: {
            nextEl: '.c-image-slider__next',
            prevEl: '.c-image-slider__prev',
          },
        pagination: {
            el: ".c-image-slider__pagination",
            clickable: true,
            type: 'progressbar',
        },
        breakpoints: {
            640: {
                spaceBetween: 10,
            },
            1200: {
                spaceBetween: 20,
            },
            1400: {
                spaceBetween: 20,
            },
        },
    })
    imageSlider.on('slideChange, init', function () {
        lazyLoad()
    });
}

export default cImageSliderInit
